<script setup lang="ts">
/**
 * Bouton dans un groupe segmenté (segmented control).
 * Le parent gère `active` et écoute `@click`.
 * Visuel : pill arrondie, accent sur active.
 */
defineProps<{
  active?: boolean;
  icon?: string; // classe Tabler ex: "ti-train"
  title?: string;
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'flex-1 flex items-center justify-center gap-1.5 px-3 py-2',
      'text-sm font-medium rounded-md transition-colors duration-160',
      active
        ? 'bg-accent text-white shadow-sm'
        : 'text-text-muted hover:text-text hover:bg-surface-muted/60',
    ]"
    :title="title"
  >
    <i v-if="icon" :class="['ti', icon, 'text-base']" aria-hidden="true"></i>
    <slot />
  </button>
</template>
